<template>
  <div class="d-flex align-items-center justify-content-center ag-overall">
    <div class="w-75">
      <h2 class="mb-5">{{$t("facilityName")}}: {{ selectedRow.facilityName  }}</h2>
      <div class="d-flex justify-content-between text-center mb-5">

        <div>
          <p class="title mb-1">{{$t("severity")}}</p>
          <p class="ag-background_error text-white small">
            {{ selectedRow.severity ?? selectedRow.Severity }}
          </p>
        </div>
        <div>
          <p class="title mb-1">Event Name</p>
          <h4>{{ selectedRow.eventType ?? selectedRow.eventTypeName }}</h4>
        </div>
        <div>
          <p class="title mb-1">{{$t("policyversion")}}</p>
          <h4>{{ selectedRow.policyVersion ?? selectedRow.PolicyFileVersion }}</h4>
        </div>
        <div>
          <p class="title mb-1">{{ $t('Event Type') }}</p>
          <h4 style="text-transform: capitalize;">{{ selectedRow.result }}</h4>
        </div>
      </div>
      <p class="text-center file">
        {{$t("CORE.ProcessPath")}}: {{ selectedRow.processPath ?? selectedRow.ProcessPath }}
      </p>

      <div v-if="selectedRow.source !== 'Heartbeat'" class="d-flex justify-content-center mt-4">
        <button class="btn" @click="openCreateIgnoreEventPopup">
          {{$t("Create Ignore Event")}}
        </button>
        <button class="btn" @click="openCreateEventSeverityPopup">
          {{$t("Create Event Severity")}}
        </button>
      </div>
      <div v-if="isCreateIgnoreEventVisible" class="modal">
        <ag-create-ignore-event @close-popup="closeCreateIgnoreEventPopup" @update-success="handleUpdateSuccess" />
      </div>
      <div v-if="isCreateEventSeverityVisible" class="modal">
        <ag-create-event-severity @close-popup="closeCreateEventSeverityPopup" @update-success="handleUpdateSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";
import AgCreateIgnoreEvent from "./components/ag-create-ignore-event.vue";
import AgCreateEventSeverity from "./components/ag-create-event-severity.vue";
const store = useStore();
export default {
  components: {
    AgCreateIgnoreEvent,
    AgCreateEventSeverity
  },
  name: "ag-overall",
  props: {
    options: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    eventDetail: null,
    isCreateIgnoreEventVisible: false,
    isCreateEventSeverityVisible: false,
  }),
  
  // mounted() {
  //   this.eventDetail = localStorage.getItem('item')
  //   localStorage.clear()
  // },
  methods: {
    handleUpdateSuccess() {
      alert('Ignore Events Filter Policy was updated successfully.');
    },
    openCreateIgnoreEventPopup() {
      this.isCreateIgnoreEventVisible = true;
    },

    openCreateEventSeverityPopup() {
      this.isCreateEventSeverityVisible = true;
    },

    closeCreateIgnoreEventPopup() {
      this.isCreateIgnoreEventVisible = false;
    },

    closeCreateEventSeverityPopup() {
      this.isCreateEventSeverityVisible = false;
    },
    
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-overall {
  padding: 20px 0px;

  button {
    box-shadow: 0px 3px 6px #00000059 !important;
    color: #1878af;
    margin-left: 1rem;
    margin-right: 1rem;
    padding: 0.7rem;
    font-size: 17px;
  }
  button:hover {
    background: #8e8e8e;
    color: white;
  }
  h2 {
    color: #5e5e5e;
  }
  h4 {
    font-weight: 300;
  }
  .title {
    color: #5e5e5e;
    font-weight: 700;
  }
  .file {
    color: #4c8dbb;
    word-break: break-all;
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);

    .w-75 {
      background: white;
      padding: 20px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
